module.exports = __webpack_public_path__ + "static/media/local-18-mobile@2x.9616235a.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/venues-and-open-hours/img/local-18-mobile@2x.png
// module id = 1186
// module chunks = 2